import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppLoaderService } from '../../services/app-loader/app-loader.service';
import { InvoiceService } from '../../appshared/invoice/invoice/invoice.service';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';

@Component({
  selector: 'app-insert-otpdialog',
  standalone: true,
  imports: [TranslateModule, CommonModule, NgOtpInputModule],
  templateUrl: './insert-otpdialog.component.html',
  styleUrls: ['./insert-otpdialog.component.scss'],
})
export class InsertOTPDialogComponent {
  ComID: number = 1;
  otp: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(InvoiceService) public servInvoice: InvoiceService,
    private toastr: ToastrService,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<InsertOTPDialogComponent>,
    private loader: AppLoaderService
  ) {}

  ngOnInit() {}
  config = {
    allowNumbersOnly: false,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '50px',
      height: '50px',
    },
  };

  onOtpChange(otp: any) {
    this.otp = otp;
  }

  onSubmit() {
    if (this.otp.length > 3) {
      this.servInvoice
        .getCheckOTP(
          this.ComID,
          this.otp,
          this.data.phoneNo,
          this.data.dialingCodes
        )
        .subscribe(
          (res) => {
            if (res == 'success') {
              this.dialogRef.close('success');
            } else {
              var transR = this.translate.instant('Wrong_OTP');
              this.toastr.warning(transR, '');
            }
          },
          (err) => {
            var transR = this.translate.instant('Wrong_OTP');
            this.toastr.warning(transR, '');
          }
        );
    }
  }
}
